export interface DocumentState {
  readonly selectedDocumentType: object;
  readonly listDocuments: any;
  readonly listDocumentsBkp: any;
  readonly listDocumentsMissing: any;
  readonly isLoading: boolean;
  readonly total: number;
}

export enum DocumentFileActionType {
  Keep = 0,
  Change = 1,
  Remove = 2,
}

export enum DocumentStatusType {
  PendenteFornecedor = 0,
  Aprovado = 1,
  Vencido = 2,
  Reprovado = 3,
  Pendente = 4,
  Faltantes = 5,
}

export interface DocumentsToGet {
  id: number;
  documentType?: Document_DocumentTypesToGet;
  documentTypeId: number;
  providerId: number;
  title: string;
  path: string;
  description: string;
  creationDate: Date | string;
  expirationDate: Date | string;
  status: DocumentStatusType | string;
  active: boolean;
  tableData?: any;
  typeDocumentName?: string;
  providerDocumentFields: DocumentsToGet_providerDocumentFields[];
  message: string;
  pageSizeOptions: number[];
  selection: boolean;
  exportAllData: boolean;
  exportButton: boolean;
  exportCsv: (columns: any, renderData: any) => void;
}
export interface DocumentsToPostEmail {
  id: number;
  documentTypeId: number;
  providerId: number;
}

export interface DocumentToPost {
  id?: number;
  documentTypeId?: number;
  providerId?: number | string;
  title?: string;
  file?: string;
  fileName?: string;
  description: string;
  expirationDate: string;
  fileAction?: DocumentFileActionType;
  status: DocumentStatusType;
  active: boolean;
  message?: string;
  providerDocumentFields?: DocumentToPost_providerDocumentFields[];
}

export interface DocumentToPost_providerDocumentFields {
  id?: number;
  documentTypeFieldId: number;
  value: string;
}

export interface DocumentsToGet_providerDocumentFields {
  id: number;
  providerDocumentId: number;
  documentTypeFieldId: number;
  value: string;
  documentTypeField: DocumentsToGet_documentTypeField;
}

export interface DocumentsToGet_documentTypeField {
  id: number;
  documentTypeId: number;
  description: string;
  fieldType: "text" | "number" | "";
  allowsNull: boolean;
  active: boolean;
}

export interface Document_DocumentTypesToGet {
  id: number;
  name: string;
  active: boolean;
  requiredDescription?: boolean;
  documentTypeFields: Document_DocumentTypesToGet_documentTypeFields[];
}

export interface Document_DocumentTypesToGet_documentTypeFields {
  id: number;
  documentTypeId: number;
  description: string;
  fieldType: "text" | "number" | "";
  allowsNull: boolean;
  active: boolean;
  answer: DocumentToPost_providerDocumentFields;
}

export interface FileUpload {
  fileName?: string;
  fileByte?: string;
}

export interface DocumentEditResponse {
  Document: DocumentToPost;
  providerDocumentFields: Document_DocumentTypesToGet;
}

export interface DocumentEmailToPost {
  providerId?: number;
  providerDocumentIds: number[];
  subject?: string;
  body?: string;
}
export interface DocumentMissingEmailToPost {
  providerIds: number[];
  providerDocumentMissing: DocumentsToPostEmail[];
  subject?: string;
  body?: string;
}

export interface SendEmailToPost {
  subject?: string | undefined;
  body?: string | undefined;
}
